export default "__VITE_ASSET__bnHRZKyl__"